import * as React from 'react';
import { TenantAppsContext } from './TenantAppsContext';

export function useTenantApps() {
    const ctx = React.useContext(TenantAppsContext);
    if (ctx === null) {
        throw new Error('useTenantApps must be used inside <TenantAppsProvider>');
    }
    return ctx;
}
